<ion-list>
    <div [style.max-height.px]="availableHeight" style="overflow-y: auto;">

        <ion-item [ngClass]="{'mobile-view': !isTablet}" button *ngFor="let timeItem of infringementTimeItems; let i = index" (click)="openInfringementDetails(timeItem)" [color]="isSuspendedItem(timeItem) ? 'warning' : null" detail="false">
            <ion-avatar *ngIf="timeItem.itemValue.penalty?.codeViolationType" slot="end">
                <div class="avatar" [style.background-color]="getTimeItemColor(timeItem)">
                    {{timeItem.itemValue.penalty?.codeViolationType.charAt(0) || timeItem.itemValue.infringementType.charAt(0)}}
                </div>
            </ion-avatar>

            <ion-avatar *ngIf="timeItem.itemValue.infringementType === 'OVERRULE'" slot="end">
                <div class="avatar" [style.border-radius.px]="0" [style.background-color]="getTimeItemColor(timeItem)">
                    {{timeItem.itemValue.penalty?.codeViolationType.charAt(0) || timeItem.itemValue.infringementType.charAt(0)}}
                </div>
            </ion-avatar>

            <ion-text color="dark" class="ion-padding">
                <span style="font-weight: 600;"> {{ timeItem.itemValue.sideNumber === 1 ? participantSide1 : timeItem.itemValue.sideNumber === 2 ? participantSide2 : null}}</span><br /> {{ timeItem.itemValue.infringementType | translate }} <span *ngIf="timeItem.itemValue.interruptionReason">({{ timeItem.itemValue.interruptionReason
                | translate }})</span> <span *ngIf="timeItem.itemValue.penalty">({{ timeItem.itemValue.penalty.penaltyType | translate }})</span>
            </ion-text>
        </ion-item>

    </div>

    <div *ngIf="!infringementTimeItems.length" class="ion-text-center">
        <app-empty-page text="{{'No violations or interruptions' | translate}}"></app-empty-page>
        <ion-button class="ion-text-center" (click)="addInfringementsOrInterruption()" fill="outline" color="tertiary">
            Add
        </ion-button>
    </div>

</ion-list>

<ion-fab *ngIf="infringementTimeItems.length" vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button color="tertiary" (click)="addInfringementsOrInterruption()">
        <ion-icon name="add"></ion-icon>
    </ion-fab-button>
</ion-fab>